import * as React from 'react';
import Radium from 'radium';
import { Parallax } from 'react-parallax';

import jumbotronLogo from '../../../../../assets/images/jumbotron_logo.png';
import mainPhoto from '../../../../../assets/images/main_photo.jpg';

@Radium
class Claim extends React.Component {

  render() {
    return (
      <Parallax bgImage={mainPhoto} style={{ width: '100%' }} strength={500}>
        <div style={styles.base}>
          <h1 style={styles.h1}>Stužák</h1>
          <h2 style={styles.h2}>Vzdělávací workshopy pro žáky středních škol.</h2>
          <h2 style={styles.h2}>Děláme to hravě.</h2>
        </div>
      </Parallax>
    );
  }
}

const styles = {
  base: {
    backgroundImage: `url(${jumbotronLogo})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left bottom',
    backgroundSize: '10% auto',
    height: 700,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    textAlign: 'center',
    paddingLeft: 0,
    paddingRight: 0
  },
  h1: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    fontSize: 40,
  },
  h2: {
    textTransform: 'none',
    fontSize: 32,
    textAlign: 'center',
    color: 'white',
  }
};

export default Claim;



// WEBPACK FOOTER //
// ./src/browser/Feature/components/claim/index.jsx